import React, { useState, useRef, useEffect } from 'react';
import {
     Redirect
    ,useLocation
    ,useHistory
}                       from 'react-router-dom';
import {
     MuiThemeProvider
    ,createTheme
}                       from '@material-ui/core/styles';
import FormControl      from '@material-ui/core/FormControl';
import TextField        from '@material-ui/core/TextField';
import Input            from '@material-ui/core/Input';
import InputAdornment   from '@material-ui/core/InputAdornment';
import IconButton       from '@material-ui/core/IconButton';
import Button           from '@material-ui/core/Button';
import Snackbar         from '@material-ui/core/Snackbar';

import MuiAlert         from '@material-ui/lab/Alert';

import GppGoodIcon      from '@material-ui/icons/Beenhere';
import Visibility       from '@material-ui/icons/Visibility';
import VisibilityOff    from '@material-ui/icons/VisibilityOff';
import AccountCircle    from '@material-ui/icons/AccountCircle';
import VpnKey           from '@material-ui/icons/VpnKey';
import moment           from 'moment';

import { useAuth }      from '../../context/auth';
import AuthService      from '../../common/AuthService';
import config           from '../../config';
import appinfo          from '../../appinfo.js';
import                       './Login.css';
import FetchService    from '../../common/FetchService';
import CommonUtilities from '../../common/CommonUtilities';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


function Login() {
    
    const bDebug        = !!config?.DEBUG?.Login;
    
    const truncateToken = CommonUtilities.truncateToken;
    
    const { search }    = useLocation();
    const isMountedRef  = useRef(true); // ref per tracciare lo stato di mount del componente
    
    const
         [ showPassword    , setShowPassword   ] = useState(false)
        ,[ isLoggedIn      , setLoggedIn       ] = useState(false)
        ,[ isAccessing     , set_isAccessing   ] = useState(false)
        ,[ isChecking      , set_isChecking    ] = useState(false)
        ,[ isRedirecting   , set_isRedirecting ] = useState(false)
        
        ,[ username        , _setUsername      ] = useState('')
        ,usernameRef = useRef(username)
        ,setUsername = data => {
            usernameRef.current = data.trim();
            _setUsername(data.trim());
        }
        
        ,[ password        , _setPassword      ] = useState('')
        ,passwordRef = useRef(password)
        ,setPassword = data => {
            passwordRef.current = data;
            _setPassword(data);
        }
        
        ,{ setTokens } = useAuth()
        ,[ sErrorMessage   , set_sErrorMessage ] = useState('')
        ,[ customer        , setCustomer       ] = useState('')
        ,[ edition         , setEdition        ] = useState('')
    ;
    
    useEffect(() => {
        
        function onKeyUp(e) {
            if ( e.key === 'Enter' ) {
                postLogin();
            }
        }
        window.addEventListener('keyup', onKeyUp);
        
        console.info(appinfo.NAME + ' version: ' + appinfo.VERSION
            + ' | Environment: ' + ( process.env.REACT_APP_ENV || 'undefined' )
        );
        
        bDebug && console.log('Login > useEffect[]: isLoggedIn',isLoggedIn);
        
        const sJwtTokenInLocalStorage   = localStorage.getItem('token');
        const sJwtTokenInURL            = (new URLSearchParams(search)?.get('token') || '');
        const isCognitoEnabled          = config.COGNITO_ENABLED === 'Y';
        
        ( async() => {
            
            if ( new URLSearchParams(window.location.search).get('out') === 'userRequest' ) {
                console.warn('manual login');
                // solo se è presente ?out=userRequest nella URL non avviene la login automatica in base ai token
                setTokens();
                return;
            }
            
            let sCognitoToken;
            if ( isCognitoEnabled ) {
                set_isChecking(true);
                await CommonUtilities.sleep(1000);
                sCognitoToken = await AuthService.firstCognitoLogin();
                set_isChecking(false);
            }
            
            if ( sCognitoToken || sJwtTokenInLocalStorage || sJwtTokenInURL ) {
                
                bDebug && sCognitoToken            && console.log('Login > useEffect[]: sCognitoToken'          , truncateToken( sCognitoToken           ,15 ) );
                bDebug && sJwtTokenInLocalStorage  && console.log('Login > useEffect[]: sJwtTokenInLocalStorage', truncateToken( sJwtTokenInLocalStorage ,15 ) );
                bDebug && sJwtTokenInURL           && console.log('Login > useEffect[]: sJwtTokenInURL'         , truncateToken( sJwtTokenInURL          ,15 ) );
                postLogin( [ sCognitoToken, sJwtTokenInLocalStorage, sJwtTokenInURL ].filter(Boolean) );
                
            } else if ( config?.HUB && ( new URLSearchParams(window.location.search).get('out') !== 'userRequest' ) ) {
                // se è stato specificato un hub, direttamente all'hub
                
                set_isRedirecting(true);
                setTimeout( () => {
                    window.location.href = 'https://' + config?.HUB + '/home';
                    // set_isRedirecting(false); // non serve perché tanto si viene rediretti
                }, 3000);
                
            }
            
        })();
        
    }, []);

    const theme = createTheme({
        overrides: { MuiTooltip: { tooltip: { fontSize: '0.9em' } } },
        palette: {
            primary: {
                main: '#509556',
            },
            secondary: {
                main: 'rgb(33, 33, 33)'
            }
        }
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        set_sErrorMessage('');
    };

    async function postLogin( asTokens ) {
        
        // se è già loggato o il componente non è ancora montato, allora esce subito da postLogin
        if ( isLoggedIn || !isMountedRef.current ) return;
        
        bDebug && console.log('Login > postLogin (non è loggato)');
        
        try {
        // Aggiungere qui la chiamata check-version-required silente (non deve mostrare errore e non deve bloccare)
            const
                 username = usernameRef.current
                ,password = passwordRef.current
            ;
            
            if ( !asTokens && ( !username || !password ) ) {
                set_sErrorMessage('Invalid username or password');
                return;
            }
            
            set_isAccessing(true);
            
            // Usa AuthService per il login (che interroga il backend, ottiene NUOVO token JWT e lo salva in localstorage)
            const oUserData = await AuthService.login({ username ,password ,asTokens });
            
            // a questo punto sei già autenticato correttamente (bisogna solo settare i token con setTokens e indicare che è loggato con setLoggedIn)
            
            const aoGeneralOpts = await FetchService.asyncGet({
                 url:                 '/get-general-options'
                ,displayErrorHandler: set_sErrorMessage
            });
            
            if ( aoGeneralOpts ) {
                
                const oGeneralOptions = ( aoGeneralOpts && aoGeneralOpts[0] ) || {};
                const sClienteDesc    = oGeneralOptions['CLIENTE_DESC'].trim() || (
                    config.ENVIRONMENTS[ process.env.REACT_APP_ENV || 'undefined' ]?.DECODE_CLIENT_COD?.[ oGeneralOptions['CLIENTE_COD'] ]
                );
                
                localStorage.setItem( 'CLIENTE_COD'             ,oGeneralOptions['CLIENTE_COD']             || ''    );
                localStorage.setItem( 'CLIENTE_DESC'            ,sClienteDesc                               || ''    );
                localStorage.setItem( 'PASSWORD_MIN_LENGTH'     ,oGeneralOptions['PASSWORD_MIN_LENGTH']     || 0     );
                localStorage.setItem( 'FLAG_UPDATE_USERS'       ,oGeneralOptions['FLAG_UPDATE_USERS']       || 'N'   );
                localStorage.setItem( 'FLAG_PORTFOLIO_REBUILD'  ,oGeneralOptions['FLAG_PORTFOLIO_REBUILD']  || 'N'   );
                localStorage.setItem( 'DATABASE_SERVER'         ,oGeneralOptions['DATABASE_SERVER']         || 'NONE');
                localStorage.setItem( 'LAMBDA_ENABLED'          ,oGeneralOptions['LAMBDA_ENABLED']          || 'N'   );
                localStorage.setItem( 'MAX_NUM_PIVOT'           ,oGeneralOptions['MAX_NUM_PIVOT']           || 1     );
                
                console.info('Customer: (' + oGeneralOptions['CLIENTE_COD'] + ') ' + sClienteDesc );
                setCustomer('(' + localStorage.getItem('CLIENTE_COD') + ') ' + localStorage.getItem('CLIENTE_DESC') );
                setEdition(oGeneralOptions['FLAG_EDITION']);
                
                // Aggiorna il contesto di autenticazione e anche localstorage
                setTokens( oUserData );
                set_isAccessing(false);
                setLoggedIn( true );
                
            } else {
                set_isAccessing(false);
                set_sErrorMessage('Unable to retrieve application data.');
            }
            
        } catch (e) {
            console.error(e);
            set_isAccessing(false);
            set_sErrorMessage(e.message || 'Authentication failed');
            AuthService.logout(); // se fallisce il login effettua comunque le operazioni di pulizia di sicurezza
        }
        
    }

    if (isLoggedIn) {
        return <Redirect to="/dashboard" />;
    }else {
        
        const env                       = process.env.REACT_APP_ENV || 'undefined';
        const DATABASE_SERVER           = localStorage.getItem('DATABASE_SERVER') || '';
        const [ ver, year, month, day ] = ( appinfo.VERSION || '' ).split('-').filter(v=>v);
        
        return (
            <div className="login">

                { sErrorMessage &&
                    <Snackbar
                        open                ={!!sErrorMessage}
                        autoHideDuration    ={6000}
                        onClose             ={handleClose}
                        anchorOrigin        ={{ vertical: 'top' ,horizontal: 'right' }}
                    >
                        <Alert onClose={handleClose} severity="error">
                            { sErrorMessage }
                        </Alert>
                    </Snackbar>
                }
    
                <div className="login-outer-container">
                    <MuiThemeProvider theme={theme}>
    
                        <div className="background-with-logo"></div>
                        <div className="background-with-logo-top-dx"></div>
                        <div className="background-with-logo-top-dx-bis"></div>
                        <div className="background-with-logo-bot-dx"></div>
                        <div className="background-with-logo-bot-dx-bis"></div>
    
                        <div id="login-form" className="login-container">
    
                            <div className="side left login-content">
        
                                <div className="header-product-name top-bottom-section">
                                    <img
                                        draggable   ="false"
                                        src         ="/roobeek_by_systrategy_logo.svg"
                                        className   ="roobeek-logo"
                                        alt         ="Roobeek®"
                                    />
                                </div>
                                
                                { isAccessing   && <div className="info-container">Accessing Application</div> }
                                
                                { isChecking    && <div className="info-container">Checking User Session</div> }
                                
                                { isRedirecting && <div className="info-container">Redirecting to Hub</div> }
                                
                                { !isAccessing && !isChecking && !isRedirecting && 
                                <div className="user-psw-container">
        
                                    <div className="form-group mb-3">
                                        <FormControl className="login-credentials-wrapper">
                                            <TextField
                                                name="email"
                                                value={username}
                                                placeholder="Username"
                                                onChange={e => {
                                                    setUsername(e.target.value);
                                                }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <AccountCircle color="secondary"/>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                style={{width: '100%'}}
                                            />
                                        </FormControl>
                                    </div>
        
                                    <div className="form-group mb-3">
                                        <FormControl className="login-credentials-wrapper">
                                            <Input
                                                name="password"
                                                id="password"
                                                placeholder="Password"
                                                type={showPassword ? 'text' : 'password'}
                                                value={password}
                                                onChange={e => {
                                                    setPassword(e.target.value);
                                                }}
                                                spellCheck={false}
                                                startAdornment={
                                                    <InputAdornment position="start">
                                                        <VpnKey color="secondary"/>
                                                    </InputAdornment>
                                                }
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={e => {
                                                                setShowPassword(!showPassword);
                                                            }}
                                                        >
                                                            {showPassword ? <Visibility/> : <VisibilityOff/>}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                        </FormControl>
                                    </div>
        
                                    { /* <div className="forgot-credentials-link"><a href="javascript:void(0);">Forgot Credentials?</a></div> */ }
        
                                    <div className="mb-3 d-flex align-items-center justify-content-between">
                                        <Button type = "default"
                                                color="primary"
                                                className="text-uppercase login-btn"
                                                onClick={(event) => postLogin()}
                                        >
                                            LOGIN
                                        </Button>
                                    </div>
    
                                </div>
                                }
                                <div className="footer-info top-bottom-section">
                                    <a href="https://www.systrategy.it" target="_blank" rel="noreferrer">
                                        <img
                                            src         ="/systrategy_logo.svg"
                                            alt         ="Systrategy"
                                            draggable   ="false"
                                            className   ="systrategy-logo"
                                        />
                                    </a>
                                </div>
                                
                            </div>
    
                            <div className={ 'side right only-logo ' + env }>
                                
                                <div className="info-top info-top-bottom">
                                    <h1   className={ 'environment ' + env }>{ env.toUpperCase() }</h1>
                                    <span className={ 'environment ' + env + ' cliente-desc' }>{ customer || '' }</span>
                                </div>
                                
                                <img draggable="false" src="/roobeek_marchio.svg" alt="Roobeek®"/>
                                
                                <div className="info-bottom info-top-bottom">
                                    
                                    <div className={ 'environment ' + env }>
                                        <span className="version-number">{ ver + ' - ' + ( moment(day + '-' + month, 'DD-MM').format('D MMM')  ) }</span>
                                        <span className="database-info">{ ( DATABASE_SERVER ).split('/')[0] }</span>
                                    </div>
                                    
                                    <div className="edition">standard edition</div>
                                    
                                </div>
                                
                            </div>
                            
                        </div>
                    </MuiThemeProvider>
                </div>
            </div>
        );
    }
}

export default Login;
